import { useSession } from '../../lib/auth/session.js';
import { logout } from '../../lib/api/client.js';
import { MfaSetup } from '../account/AccountSecurityPage.js';
import { AuthLayout } from './AuthLayout.js';

/**
 * Two-step verification before anything else, for somebody whose role requires it (owner,
 * 3 October 2026: "2fa should be compulsory for platform admins, msps and tms admins"). The API
 * answers nothing else for them until it is on (plugins/authenticate.ts), so this is the whole
 * screen: set it up, or sign out.
 */
export function MfaRequiredPage() {
  const email = useSession((s) => s.session?.user.email);
  return (
    <AuthLayout>
      <h1 className="arc-h1">Set up two-step verification</h1>
      <p className="arc-muted" style={{ marginTop: 6, fontSize: 13.5, lineHeight: 1.55 }}>
        Your role needs a code from an authenticator app as well as your password. Set it up once
        for <strong>{email}</strong> and you can carry on.
      </p>
      <div style={{ marginTop: 18 }}>
        <MfaSetup />
      </div>
      <button type="button" className="arc-btn arc-btn-ghost arc-btn-sm" style={{ marginTop: 18 }}
        onClick={() => { void logout(); }}>
        Sign out
      </button>
    </AuthLayout>
  );
}
